import { difference } from "lodash";
import { useCallback } from "react";

type Params<ItemId> = {
    selectedValue: ReadonlyArray<ItemId> | null | undefined;
    onValueChange: (values: ReadonlyArray<ItemId>) => void;
};

type ReturnValue<ItemId> = {
    onSelect(id: ItemId | readonly ItemId[], isSelected: boolean): void;
};

const useMultiselectHandler = <ItemId>({ selectedValue, onValueChange }: Params<ItemId>): ReturnValue<ItemId> => {
    const handleSelect = useCallback(
        (id: ItemId | ItemId[], isSelected: boolean) => {
            const comparableSelectedValue = selectedValue ?? [];
            const valuesArray = Array.isArray(id) ? id : [id];

            const changedValue = isSelected
                ? difference(comparableSelectedValue, valuesArray)
                : Array.from(new Set(comparableSelectedValue.concat(valuesArray)));

            onValueChange(changedValue);
        },
        [selectedValue, onValueChange],
    );

    return {
        onSelect: handleSelect,
    };
};

export default useMultiselectHandler;
